<template lang="pug">
  .lib-cat-menu.text-app-text(v-show="visible")
    //- (mobile open button)
    .fixed.z-40.md-hidden.right-0.pointer-events-none.font-sabon(:class="{'z-50 top-0 w-full flex justify-center pt-15': mblMenu, 'bottom-0 w-1x2 pb-ios sm-pb-75 pl-40': !mblMenu}", v-show="!hideBtn")
      button.relative.flex.items-center.justify-center.h-40.w-90.pointer-events-auto(@click="mblMenu = !mblMenu")
        svg-ellipse.absolute.inset-0.w-full.h-full.text-gray-300.fill-app-bg
        .relative.z-10(v-show="!mblMenu")
          span.text-12.block.pt-2 Library
          span.text-15.block.leading-none(style="margin-top:-.6em") &hellip;
        svg-x.w-15.h-15.relative.z-10(v-show="mblMenu")

    //- menu
    .fixed.z-40.md-z-20.w-full.top-0.left-0.w-full.font-sabon.flex.justify-center
      //- (scrim)
      transition(name="fade")
        .hidden.md-block.absolute.inset-0.w-full(v-show="menuVisible", @mouseenter="menuVisible = active = false", @click="menuVisible = false")
          .bg-app-bg.opacity-95.h-screen
      //- menu (overlay on mobile)
      transition(:name="menuAnim")
        nav.fixed.z-40.inset-0.bg-app-bg.h-screen.overflow-y-scroll.scrolling-touch.md-static.md-h-auto.md-bg-transp.md-overflow-visible(v-show="mblMenu || winIs('md')")
          transition(:name="menubodyAnim")
            .px-10.pt-75.pb-60.md-p-0.md-flex(v-show="mblMenu || winIs('md')")
              //- groups
              ul.list-reset.border-t.pt-24.pb-40.relative.z-10.md-py-0.md-border-none(v-for="(cat, i) in menu")
                header.md-h-67.md-flex.items-center
                  h6.text-14.relative.z-10.cursor-default.md-text-18.italic.md-not-italic.md-px-30(@mouseenter="show(i)", @click="show(i)") {{cat.name}}
                //- sub categories
                transition(:name="catListAnim")
                  .pt-10.w-3x4.ml-auto.md-absolute.top-0.md-w-auto.md-ml-30.md-pt-67.md-pb-40.md-h-50vh.md-min-h-420.md-columns-11em.text-21.md-text-18(v-show="!winIs('md') || active === i", style="column-gap:0")
                    //- template(v-for="n in (i > 1) ? 5 : 1")
                    li.pl-5.md-pl-0.md-w-11em.md-pr-30(v-for="child in cat.items")
                      router-link.hover-text-app-accent(:to="rt(child)") {{child.name}}

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import svgEllipse from '@/components/Icons/SVG-Ellipse'
import svgX from '@/components/Icons/SVG-X'
export default {
  name: 'LibraryCategoriesMenu',
  props: ['hideBtn'],
  data () {
    return {
      visible: false,
      menuVisible: false,
      mblMenu: false,
      active: -1
    }
  },
  computed: {
    ...mapState(['site', 'categories', 'transition']),
    ...mapGetters(['winIs']),
    menu () {
      return this.site && this.site.library_categories.map(itm => {
        return {
          name: itm.category.name,
          slug: itm.category.slug,
          items: this.categories.filter(cat => cat.parent === itm.category.term_id)
        }
      })
    },
    menuAnim () {
      return this.winIs('md') ? 'none' : 'menu'
    },
    menubodyAnim () {
      return this.winIs('md') ? 'none' : 'menubody'
    },
    catListAnim () {
      return this.winIs('md') ? 'cat-list' : 'none'
    }
  },
  methods: {
    rt (cat) {
      return { name: 'category', params: { cat: cat.slug } }
    },
    show (i) {
      this.menuVisible = true
      this.active = i
    },
    hide () {
      this.menuVisible = false
      this.mblMenu = false
      this.active = -1
    }
  },
  watch: {
    '$route' () {
      this.hide()
    },
    mblMenu (vis) {
      this.$emit('mblMenu', vis)
    }
  },
  created () {
    this.$store.dispatch('getCategories')
    // show after rt leave
    this.$root.$on('triggerScroll', () => { this.visible = true })
  },
  mounted () {
    // initial visibility
    this.visible = this.transition !== 'openbook'
  },
  components: { svgEllipse, svgX }
}
</script>

<style>
/* show category children on hover */
/* apply to li because otherwise is cut-off by CSS columns rule */
.cat-list-enter-active { &, & li {transition: opacity 600ms;}}
.cat-list-leave-active { &, & li {transition: opacity 150ms;}}
.cat-list-enter, .cat-list-leave-to{ &, & li {opacity:0;}}
</style>
